module.exports = __webpack_public_path__ + "img/costEffective.da27dd87.jpg";